import React from 'react';
import { Search, Plus, Filter } from 'lucide-react';
interface LeadFiltersProps {
  onNew?: () => void;
}
export function LeadFilters({
  onNew
}: LeadFiltersProps) {
  return <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6" data-id="element-401">
      <div className="flex-1 flex flex-col sm:flex-row gap-3" data-id="element-402">
        <div className="relative max-w-md w-full" data-id="element-403">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-404">
            <Search className="h-4 w-4 text-growthly-muted" data-id="element-405" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2.5 border border-white/10 rounded-lg leading-5 bg-growthly-bg text-growthly-text placeholder-growthly-muted focus:outline-none focus:ring-1 focus:ring-growthly-amber focus:border-growthly-amber sm:text-[13px] transition-colors" placeholder="Buscar por nombre, decisor, teléfono... (F)" data-id="element-406" />
        </div>

        <div className="flex items-center space-x-2 overflow-x-auto pb-1 sm:pb-0 hide-scrollbar" data-id="element-407">
          <button className="btn-secondary inline-flex items-center whitespace-nowrap" data-id="element-408">
            <Filter className="w-4 h-4 mr-2 text-growthly-muted" data-id="element-409" />
            Filtros
          </button>
          <select className="block w-full pl-3 pr-8 py-2 text-[13px] border border-white/10 rounded-lg focus:outline-none focus:ring-1 focus:ring-growthly-amber focus:border-growthly-amber bg-growthly-bg text-growthly-text" data-id="element-410">
            <option data-id="element-411">Prioridad (Todas)</option>
            <option data-id="element-412">ICP A</option>
            <option data-id="element-413">ICP B</option>
            <option data-id="element-414">ICP C</option>
          </select>
          <select className="block w-full pl-3 pr-8 py-2 text-[13px] border border-white/10 rounded-lg focus:outline-none focus:ring-1 focus:ring-growthly-amber focus:border-growthly-amber bg-growthly-bg text-growthly-text" data-id="element-415">
            <option data-id="element-416">Estado (Todos)</option>
            <option data-id="element-417">Nuevo</option>
            <option data-id="element-418">Contactado</option>
            <option data-id="element-419">Conversación</option>
            <option data-id="element-420">Micro-acuerdo</option>
          </select>
        </div>
      </div>

      <div className="flex-shrink-0" data-id="element-421">
        <button onClick={onNew} className="btn-primary w-full sm:w-auto inline-flex items-center justify-center gap-2" data-id="element-422">
          <Plus className="w-4 h-4" data-id="element-423" />
          Nuevo Lead
          <kbd className="ml-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded border border-black/20 bg-black/10 text-[10px] font-semibold text-[#0B0B0B]/70 hidden sm:inline-flex" data-id="element-424">
            N
          </kbd>
        </button>
      </div>
    </div>;
}